const validation_helper = require("../common/input_validation");

/**
 * Inputs, checkbox and radiobox
 */
$(function() {

  /* Radiobox */

  const $radiobox = $('.radiobox input[type="radio"]');

  function radiobox_state () {
    $('input[name="' + $(this).attr('name') + '"]').each(function () {
      const $container = $(this).closest('.radiobox');

      if($(this).is(':checked')){
        $container.addClass('checked');
        $container.find('input[type="text"], textarea').prop('disabled', false);
      }
      else {
        $container.removeClass('checked');
        $container.find('.error-message').remove();
        $container.find('.error').removeClass('error');
        $container.find('input[type="text"], textarea').prop('disabled', true);
      }
    });
  }

  $radiobox.on('change', radiobox_state);
  $radiobox.each(radiobox_state); // Init

  const $radiobox_inputs = $('.radiobox textarea, .radiobox input[type=text]');
  $radiobox_inputs.on('keyup', function () {
    $(this).closest('.radiobox').find('.error-message').remove();
    $(this).closest('.radiobox').find('.error').removeClass('error');
  });

  /* Checkbox  */

  const $checkbox_input = $('.checkbox.custom input');

  function checkbox_state () {
    $(this).is(':checked') ? $(this).parents('.checkbox.custom').addClass('checked') : $(this).parents('.checkbox.custom').removeClass('checked');
  }

  $checkbox_input.on('change', checkbox_state);
  $checkbox_input.each(textbox_state); // Init

  /* Inputs */

  const $textbox_input = $('.text-box input, .text-box-2 input');

  function textbox_state () {
    if (($(this).val() || '').length > 0) {
      $(this).addClass('valid');
    } else {
      $(this).removeClass('valid');
    }
  }

  $textbox_input.on('change', textbox_state);

  $textbox_input.on('keyup', function(e) {
    if(e.which !== 13){
      validation_helper.clear_errors($(this).parent());
    }
  });


  $textbox_input.each(textbox_state); // Init

});